module.exports = __webpack_public_path__ + "img/bell@2x.2d627a58.png";